import { Navigate, useParams } from 'react-router-dom';

import { useGetMantenimiento } from '@/shared/actions/erp/activos';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveMantenimiento } from '../../shared/saveMantenimiento';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateMantenimientoPageInterface {}

const UpdateMantenimientoPage: React.FC<UpdateMantenimientoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_ice)

  const { id } = useParams();
  const { data, isLoading } = useGetMantenimiento(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_mantenimiento_activo) return <Navigate to="/activos/mantenimiento" />;

  return <SaveMantenimiento titlePage="Editar Grupo Activos" editMantenimiento={data.data} />;
};

export default UpdateMantenimientoPage;
